export const POPULATE_INITIAL_BLOCKS = 'canvasBlocksTypes/POPULATE_INITIAL_BLOCKS';
export const SWITCH_LOCK_STRUCTURE = 'canvasBlocksTypes/SWITCH_LOCK_STRUCTURE';
export const ADD_BLOCK = 'canvasBlocksTypes/ADD_BLOCK';
export const DUPLICATE_BLOCKS = 'canvasBlocksTypes/DUPLICATE_BLOCKS';
export const REMOVE_BLOCK = 'canvasBlocksTypes/REMOVE_BLOCK';
export const MOVE_BLOCKS = 'canvasBlocksTypes/MOVE_BLOCKS';
export const SWAP_BLOCKS = 'canvasBlocksTypes/SWAP_BLOCKS';
export const LOCK_BLOCKS = 'canvasBlocksTypes/LOCK_BLOCKS';
export const DELETE_BLOCKS = 'canvasBlocksTypes/DELETE_BLOCKS';
export const UPDATE_BLOCKS_PROPERTIES = 'canvasBlocksTypes/UPDATE_BLOCKS_PROPERTIES';
